import { render } from "./AddGiftValues.vue?vue&type=template&id=56427e90"
import script from "./AddGiftValues.vue?vue&type=script&lang=js"
export * from "./AddGiftValues.vue?vue&type=script&lang=js"

import exportComponent from "/home/cleanbee/web/admin.cleanbee.lt/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__